module.exports = __webpack_public_path__ + "img/btn2.ee138306.png";